import request from "@/utils/request";

const api = {
    getAllApp: "/app/getAllApp",
    hasApp: "/app/hasApp",
    listPlatformConfig: "/app/listPlatformConfig",
};

export function getAllApp(parameter) {
    return request({
        url: api.getAllApp,
        method: "get",
        params: parameter,
    });
}

export function hasApp(parameter) {
    return request({
        url: api.hasApp,
        method: "get",
        params: parameter,
    });
}

export function listPlatformConfig() {
    return request({
        url: api.listPlatformConfig,
        method: "get"
    });
}
